<script>
import TermsOfServices from "./terms_of_services.vue";

export default TermsOfServices;
</script>
